import type { LitterLinksGetBreedsQuery } from '@gql/graphql';
import type { SelectOption } from '@presentation/components';
import { sortBy } from 'lodash/fp';
import { useMemo } from 'react';

export const useFormatBreeds = (breeds?: LitterLinksGetBreedsQuery['findManyDogBreed'] | null) => {
  const breedOptionsBasenameKey: SelectOption<string>[] = useMemo(() => {
    return sortBy((b) => b.translations?.[0]?.name?.toLocaleLowerCase(), breeds).map(
      (breed) =>
        ({
          value: breed.baseBreedName ?? breed.name,
          label: breed.translations[0].name,
          searchValues: breed.translations[0].otherNames,
        } as SelectOption<string>),
    );
  }, [breeds]);

  return { breedOptionsBasenameKey };
};
